/**
 * Expert reply drafts: the `.draft` composer shortcut and the draft screen it opens,
 * a full-screen route on a phone and a modal on web. The chat composes them
 * from above; the hand-off link the send reads lives in the narrower `/state`
 * entry.
 */
export { ReplyDraftModal } from './ui/screen/ReplyDraftModal';
export { ReplyDraftScreen } from './ui/screen/ReplyDraftScreen';
export { DraftReplyChip } from './ui/shortcut/DraftReplyChip';
export { useReplyDraftShortcut, type ReplyDraftModalState } from './hooks/useReplyDraftShortcut';
